import React from "react";



export default ({className, ...props}: React.HTMLAttributes<HTMLElement>) => {
  return <i className={`fa-solid fa-xmark ${className ? className : ''}`}  {...props}></i>
}
